// eslint-disable-next-line no-restricted-globals
export const refWindow = window;
export const refDocument = document;
